import { isPrerenderStaffEmail } from '@prerender/prerender-shared/FE';

import { usePrerenderEmail } from '../../hooks/usePrerenderUser';
import { type SearchPerformancePagesSourceType } from './api/searchPerformanceApi';
import { INSPECTED_WITHIN_DAYS } from './UrlInspectionWindow';

export { INSPECTED_WITHIN_DAYS };

// Staff impersonating a customer stay outside: the session email is the
// customer's (see `isImpersonationToken`).
export function useUrlInspectionAccess(): boolean {
  return isPrerenderStaffEmail(usePrerenderEmail());
}

export function inspectedWithinDays(
  source: SearchPerformancePagesSourceType,
  hasUrlInspectionAccess: boolean
): number | undefined {
  return hasUrlInspectionAccess && source === 'GSC' ? INSPECTED_WITHIN_DAYS : undefined;
}
